import "./Testimonials.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import button from "../assets/button.png";
import symbol from "../assets/symbol.png";
import f1 from "../assets/pic1.png";
import f2 from "../assets/pic2.png";
import f3 from "../assets/pic3.png";
import f4 from "../assets/pic4.png";
const Testimonials = () => {
  const data = [
    {
      id: 1,
      image: f1,
      name: "Rohan Malhotra",
      position: "— Mumbai, India",
      feedback:
        "Our team needed an ML solution that wouldn’t slow down as our data continued to increase. The results were better than expected—accurate predictions and a noticeable improvement in workflow efficiency.",
    },
    {
      id: 2,
      image: f2,
      name: "Arjun Desai",
      position: "— Ahmedabad, India",
      feedback:
        "We were struggling to make sense of our scattered data, but their ML approach brought clarity fast. The automation they set up saved our team hours every week.",
    },
    {
      id: 3,
      image: f3,
      name: "Daniel Parker",
      position: "— London, UK",
      feedback:
        "The insights we got were far more accurate than expected. Their ML solutions helped us refine our decisions and improve customer experience without adding extra workload.",
    },
    {
      id: 4,
      image: f4,
      name: "Sofia Martins",
      position: "— SaaS Platform, Bangalore",
      feedback:
        "Our forecasting system is now far more accurate than before. The team explained everything clearly and delivered a solution that genuinely supports our business decisions.",
    },
  ];
  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    nextArrow: <img src={button} alt="Next" className="nextArrow" />,
    prevArrow: <img src={button} alt="Previous" className="prevArrow" />,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <div id="testimonialsclass" className="machinemainclass">
      <h2 className="heading">Trusted by Users Across the Globe</h2>
      <Slider {...settings}>
        {data.map((item) => {
          return (
            <div className="fwrapper" key={item.id}>
              <div className="fbox">
                <div className="symbolbox">
                  <img src={symbol} alt="" className="symbolimage" />
                </div>
                <div className="fcontent">
                  <p>{item.feedback}</p>
                  <div className="personinfo">
                    <h3>{item.name}</h3>
                    <h4>{item.position}</h4>
                  </div>
                </div>
                <div className="profilebox">
                  <img src={item.image} alt="" className="profileimage" />
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default Testimonials;
